import React, { useContext, useEffect, useMemo } from 'react'
import { instana as Monitoring } from '../../utils/monitoring/instana'
import { useAsync } from 'react-use'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import { UserPreferencesContext } from '../preferences/UserPreferencesContext'
import { buildLaunchDarklyContext } from '../../userprofile/launchdarkly'

const LaunchDarklyProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const profile = useContext(UserPreferencesContext)

  const ldContext = useMemo(() => {
    return !profile.email ? { key: 'anonymous' } : buildLaunchDarklyContext(profile)
  }, [profile])

  useEffect(() => {
    Monitoring.trace(`LD Client ID: ${window.ENV.REACT_APP_LAUNCHDARKLY_KEY}`)
    Monitoring.trace(`LD Context: ${JSON.stringify(ldContext)}`)
  }, [ldContext])

  const { value: ProviderComponent } = useAsync(async () => {
    return await asyncWithLDProvider({
      clientSideID: window.ENV.REACT_APP_LAUNCHDARKLY_KEY,
      context: ldContext,
    })
  }, [ldContext])

  if (!ProviderComponent) return null

  return <ProviderComponent>{children}</ProviderComponent>
}

export default LaunchDarklyProvider
